/**
 * 便签节点 - 用于在画布上添加说明标签
 */
import React, { memo, useState, useEffect } from 'react';
import { useReactFlow } from '@xyflow/react';
import { useProject } from '../providers/ProjectProvider';
import { useNodeOperations } from '../providers/NodeOperationsProvider';
import './NoteNode.css';

export const NoteNode = memo(({ id, data }) => {
  const { updateNodeData } = useReactFlow();
  const { readOnly } = useProject();
  const { duplicateNode } = useNodeOperations();
  
  const [text, setText] = useState(data.text || '在此输入说明...');
  const [color, setColor] = useState(data.color || '#fff9db'); // 默认黄色便签
  const [showColorPicker, setShowColorPicker] = useState(false);

  // 预设颜色
  const presetColors = [
    { name: '黄色', value: '#fff9db' },
    { name: '粉色', value: '#ffe4e1' },
    { name: '绿色', value: '#e1f5e1' },
    { name: '蓝色', value: '#e1f0ff' },
    { name: '紫色', value: '#f0e6ff' },
    { name: '橙色', value: '#ffe8d1' },
    { name: '白色', value: '#ffffff' },
    { name: '灰色', value: '#f5f5f5' },
  ];

  useEffect(() => {
    updateNodeData(id, {
      text,
      color,
    });
  }, [id, text, color, updateNodeData]);

  const handleTextChange = (e) => {
    if (!readOnly) {
      setText(e.target.value);
    }
  };

  const handleColorChange = (newColor) => {
    if (!readOnly) {
      setColor(newColor);
      setShowColorPicker(false);
    }
  };

  const handleDuplicate = (e) => {
    e.stopPropagation();
    duplicateNode(id);
  };

  return (
    <div className="NoteNode-container" style={{ backgroundColor: color }}>
      {/* 复制按钮 */}
      <button 
        className="NoteNode-duplicate-button"
        onClick={handleDuplicate}
        title="复制节点"
      >
        <i className="bi bi-copy"></i>
      </button>

      {/* 便签头部 */}
      <div className="NoteNode-header">
        <span className="NoteNode-icon">📌</span>
        <span className="NoteNode-title">便签</span>
        {!readOnly && (
          <button
            className="NoteNode-color-btn"
            onClick={() => setShowColorPicker(!showColorPicker)}
            title="更改颜色"
          >
            🎨
          </button>
        )}
      </div>

      {/* 颜色选择器 */}
      {showColorPicker && !readOnly && (
        <div className="NoteNode-color-picker">
          {presetColors.map((preset) => (
            <button
              key={preset.value}
              className="NoteNode-color-option"
              style={{ backgroundColor: preset.value }}
              onClick={() => handleColorChange(preset.value)}
              title={preset.name}
            />
          ))}
        </div>
      )}

      {/* 文本输入区域 */}
      <textarea
        value={text}
        onChange={handleTextChange}
        disabled={readOnly}
        className="NoteNode-textarea"
        placeholder="在此输入说明..."
        rows={6}
      />
    </div>
  );
});

NoteNode.displayName = 'NoteNode';

